import React from 'react';
import { withTranslation } from '../../../Translator';
import Stack from '../../../Stack';
import Popover from '../../../Popover';
import { RadioButtonGroup } from '../../../RadioButtonGroup';
import Header from '../../../Header';
import * as Types from '../../types';

const TypesFilter = ({ value, onSelected, t }) => (
  <Popover.Section padding="narrow">
    <Stack vertical spacing="narrow">
      <Stack.Item>
        <Header type="small">{t('WebsitePicker.label.type')}</Header>
      </Stack.Item>
      <Stack.Item>
        <RadioButtonGroup
          name="type"
          value={value}
          options={[
            {
              label: t('WebsitePicker.types.all'),
              id: Types.all,
              value: Types.all,
            },
            {
              label: t('WebsitePicker.types.websites'),
              id: Types.website,
              value: Types.website,
            },
            {
              label: t('WebsitePicker.types.meta-sites'),
              id: Types.metaSite,
              value: Types.metaSite,
            },
          ]}
          onChange={(event) => { onSelected(event.target.value); }}
        />
      </Stack.Item>
    </Stack>
  </Popover.Section>
);

const enhanced = withTranslation('components')(TypesFilter);

export { TypesFilter as PureComponent };
export default enhanced;
